import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LandingPageComponent } from './components/landing-page/landing-page/landing-page.component';
import { MainComponent } from './components/main/main.component';
import { PaymentCompleteComponent } from './components/subscribtion/payment-complete/payment-complete.component';
import { RouletteSubscribtionComponent } from './components/subscribtion/roulette-subscribtion/roulette-subscribtion.component';
import { RouletteComponent } from './components/web-roulette/roulette/roulette.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { RefundCancellationPolicyComponent } from './components/refund-cancellation-policy/refund-cancellation-policy.component';

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', component: LandingPageComponent },
    {path:'termsOfUse',component:TermsOfUseComponent},
    {path:'privacyPolicy',component:PrivacyPolicyComponent},
    {path:'RefundCancellationPolicy',component:RefundCancellationPolicyComponent},
    { path: 'roulette', component: RouletteComponent },
    { path: 'roulette/:id', component: RouletteComponent },
  ])
  ],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
